module.exports = __webpack_public_path__ + "8d0a0f4dba8e0f6747d426382991b170.png";